import React, { useState, useEffect, useCallback } from 'react';
import { getAdminNavGroups } from './adminNavConfig.js';
import { canAccessTab } from '../../config/adminPermissions.js';

const NavIcon = ({ tabId }) => {
  const props = { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2 };

  switch (tabId) {
    case 'dashboard':
      return (
        <svg {...props}>
          <rect x="3" y="3" width="7" height="9" />
          <rect x="14" y="3" width="7" height="5" />
          <rect x="14" y="12" width="7" height="9" />
          <rect x="3" y="16" width="7" height="5" />
        </svg>
      );
    case 'statistics':
      return (
        <svg {...props}>
          <path d="M4 19V5" strokeLinecap="round" />
          <path d="M4 19h16" strokeLinecap="round" />
          <rect x="7" y="11" width="2.8" height="5" rx="0.8" fill="currentColor" stroke="none" />
          <rect x="11.6" y="7" width="2.8" height="9" rx="0.8" fill="currentColor" stroke="none" />
          <rect x="16.2" y="4" width="2.8" height="12" rx="0.8" fill="currentColor" stroke="none" />
        </svg>
      );
    case 'clinics':
      return (
        <svg {...props}>
          <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
          <polyline points="9 22 9 12 15 12 15 22" />
        </svg>
      );
    case 'users':
    case 'roles':
      return (
        <svg {...props}>
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
          <circle cx="9" cy="7" r="4" />
          <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
          <path d="M16 3.13a4 4 0 0 1 0 7.75" />
        </svg>
      );
    case 'licenses':
      return (
        <svg {...props}>
          <path d="M20 7h-9" />
          <path d="M14 17H5" />
          <circle cx="17" cy="17" r="3" />
          <circle cx="7" cy="7" r="3" />
        </svg>
      );
    case 'health-check':
      return (
        <svg {...props}>
          <path d="M22 12h-4l-3 9L9 3l-3 9H2" />
        </svg>
      );
    case 'products':
      return (
        <svg {...props}>
          <rect x="3" y="3" width="7" height="7" />
          <rect x="14" y="3" width="7" height="7" />
          <rect x="14" y="14" width="7" height="7" />
          <rect x="3" y="14" width="7" height="7" />
        </svg>
      );
    case 'announcements':
      return (
        <svg {...props}>
          <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
          <path d="M13.73 21a2 2 0 0 1-3.46 0" />
        </svg>
      );
    case 'inquiries':
      return (
        <svg {...props}>
          <g fill="currentColor" stroke="currentColor">
            <path d="M2.5 12.5H6.5" strokeWidth={2.75} fill="none" strokeLinecap="round" />
            <path d="M6 10.25 9 12.5 6 14.75Z" stroke="none" />
          </g>
          <path d="M9 8h11a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1z" />
          <path d="M20 9 14.5 12.5 9 9" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      );
    case 'email-settings':
      return (
        <svg {...props}>
          <path d="M4 8h11a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1z" />
          <path d="M15 9 9.5 12.5 4 9" strokeLinecap="round" strokeLinejoin="round" />
          <g fill="currentColor" stroke="currentColor">
            <path d="M16.5 12.5H19.5" strokeWidth={2.75} fill="none" strokeLinecap="round" />
            <path d="M19 10.25 22 12.5 19 14.75Z" stroke="none" />
          </g>
        </svg>
      );
    case 'logs':
    case 'legal':
      return (
        <svg {...props}>
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
          <polyline points="14 2 14 8 20 8" />
          <line x1="16" y1="13" x2="8" y2="13" />
          <line x1="16" y1="17" x2="8" y2="17" />
          <polyline points="10 9 9 9 8 9" />
        </svg>
      );
    case 'hp-management':
      return (
        <svg {...props}>
          <rect x="2" y="4" width="20" height="16" rx="2" />
          <path d="M2 9h20" />
          <circle cx="5.5" cy="6.5" r="0.6" fill="currentColor" stroke="none" />
          <circle cx="8" cy="6.5" r="0.6" fill="currentColor" stroke="none" />
          <path d="M7 14h6M7 17h10" strokeLinecap="round" />
        </svg>
      );
    case 'invitation-rewards':
      return (
        <svg {...props}>
          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
        </svg>
      );
    case 'accounting':
      return (
        <svg {...props}>
          <rect x="3" y="4" width="18" height="16" rx="2" />
          <path d="M7 8h10M7 12h6M7 16h8" strokeLinecap="round" />
        </svg>
      );
    case 'allowlist':
      return (
        <svg {...props}>
          <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
          <circle cx="8.5" cy="7" r="4" />
          <polyline points="17 11 19 13 23 9" />
        </svg>
      );
    case 'settings':
      return (
        <svg {...props}>
          <circle cx="12" cy="12" r="3" />
          <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" />
        </svg>
      );
    case 'notifications':
      return (
        <svg {...props}>
          <path d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9" />
          <path d="M13.73 21a2 2 0 01-3.46 0" />
        </svg>
      );
    case 'dev-test':
      return (
        <svg {...props}>
          <path d="M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l3.77-3.77a6 6 0 01-7.94 7.94l-6.91 6.91a2.12 2.12 0 01-3-3l6.91-6.91a6 6 0 017.94-7.94l-3.76 3.76z" />
        </svg>
      );
    default:
      return (
        <svg {...props} overflow="visible">
          <circle cx="12" cy="12" r="9" />
        </svg>
      );
  }
};

const AdminSidebarNav = ({ activeTab, onSelectTab, user }) => {
  const groups = getAdminNavGroups().map((group) => ({
    ...group,
    items: group.items.filter((item) => canAccessTab(user, item.id)),
  })).filter((group) => group.items.length > 0);
  const [expandedGroups, setExpandedGroups] = useState(
    () => new Set(groups.map((group) => group.id))
  );

  useEffect(() => {
    setExpandedGroups((prev) => {
      const next = new Set(prev);
      groups.forEach((group) => next.add(group.id));
      return next;
    });
  }, [user]);

  const toggleGroup = useCallback((groupId) => {
    setExpandedGroups((prev) => {
      const next = new Set(prev);
      if (next.has(groupId)) {
        next.delete(groupId);
      } else {
        next.add(groupId);
      }
      return next;
    });
  }, []);

  const handleSelect = (e, tabId) => {
    e.preventDefault();
    onSelectTab(tabId);
  };

  return (
    <nav id="admin-sidebar-nav" className="sidebar-nav">
      <a
        href="#"
        className={`nav-item ${activeTab === 'dashboard' ? 'active' : ''}`}
        onClick={(e) => handleSelect(e, 'dashboard')}
        style={canAccessTab(user, 'dashboard') ? undefined : { display: 'none' }}
      >
        <NavIcon tabId="dashboard" />
        ダッシュボード
      </a>

      <a
        href="#"
        className={`nav-item ${activeTab === 'statistics' ? 'active' : ''}`}
        onClick={(e) => handleSelect(e, 'statistics')}
        style={canAccessTab(user, 'statistics') ? undefined : { display: 'none' }}
      >
        <NavIcon tabId="statistics" />
        統計
      </a>

      {groups.map((group) => {
        const isExpanded = expandedGroups.has(group.id);
        const hasActiveChild = group.items.some((item) => item.id === activeTab);

        return (
          <div
            key={group.id}
            className={`nav-group${isExpanded ? ' expanded' : ''}${hasActiveChild ? ' has-active' : ''}`}
          >
            <button
              type="button"
              className="nav-group-toggle"
              onClick={() => toggleGroup(group.id)}
              aria-expanded={isExpanded}
            >
              <span className="nav-group-label">{group.label}</span>
              <svg
                className="nav-group-chevron"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                aria-hidden="true"
              >
                <polyline points="6 9 12 15 18 9" />
              </svg>
            </button>

            <div className={`nav-group-children${isExpanded ? ' is-open' : ''}`}>
              <div className="nav-group-children-inner">
                {group.items.map((item) => (
                  <a
                    key={item.id}
                    href="#"
                    className={`nav-item nav-sub-item ${activeTab === item.id ? 'active' : ''}`}
                    onClick={(e) => handleSelect(e, item.id)}
                  >
                    <NavIcon tabId={item.id} />
                    {item.label}
                  </a>
                ))}
              </div>
            </div>
          </div>
        );
      })}
    </nav>
  );
};

export default AdminSidebarNav;
